import { useConsultDoctorContext } from "../../Contexts/ConsultDoctorContext";
import SaveSuccessModal from "./SaveSuccessModal";
import { CircularProgress } from "@mui/material";
import SaveFailedModal from "./SaveFailedModal";
import success from "../../assets/success.png";
import Button from "../../Components/Button";
import dayjs from "dayjs";

function StepFiveSuccess() {
  const {
    showSuccessSaveModal,
    showSaveFailedModal,
    handleSaveDoctor,
    setSelectedDate,
    selectedDate,
    resetStates,
    loadState,
    navigate,
  } = useConsultDoctorContext();

  let successSaveModal = showSuccessSaveModal && <SaveSuccessModal />;
  let saveFailedModal = showSaveFailedModal && <SaveFailedModal />;

  return (
    <div className="flex flex-col min-h-screen sm:items-center sm:bg-[#E7EEFA]">
      <div className="flex flex-col flex-1 sm:flex-none bg-white sm:w-148 sm:items-center rounded-xl sm:my-24">
        <div className="flex flex-col items-center justify-center text-center p-4 mt-auto">
          <img src={success} alt="Personal" className="w-24 my-4" />
          <p className="text-xl font-bold mb-3">Booking successful!</p>
          <p>
            Your appointment is confirmed for{" "}
            <span className="font-bold">
              {dayjs(selectedDate).format("MMMM DD, YYYY")}
            </span>
            {/* */}. We'll be ready to assist you. If you need any assistance or
            have questions, please don't hesitate to contact us.
          </p>
        </div>

        <div className="w-full p-4 mt-auto">
          <Button
            id="saveDoctorBtn"
            className={`w-full h-14 border mb-3 sm:mr-4 ${
              loadState === "save" ? "bg-[#f2f2f2]" : "bg-white"
            }`}
            onClick={handleSaveDoctor}
          >
            <p
              className={` ${
                loadState === "save" ? "text-[#828282]" : "text-[#000000]"
              }`}
            >
              {loadState === "save" ? (
                <CircularProgress size={"1rem"} />
              ) : (
                "Save for next consultation"
              )}
            </p>
          </Button>
          <Button
            className="w-full h-14 text-white sm:mr-3"
            onClick={(e) => {
              setSelectedDate();
              navigate("/home");
              resetStates();
            }}
          >
            Back to dashboard
          </Button>
        </div>
      </div>
      {successSaveModal}
      {saveFailedModal}
    </div>
  );
}

export default StepFiveSuccess;
